import React, { useState, useEffect } from "react";
import { Form, Button, Col, Container, Row } from "react-bootstrap";
import MaskedInput from "react-text-mask";
import {
  CUSTOM_WELL_FORM_SELECT_STYLES,
  EMPTY,
  STATES,
} from "../../../configurations/Constants";
import Select from "react-select";
import _ from "lodash";
import {
  ENTER_VALID_PHONE_NUMBER,
  ENTER_WELL_OWNER_NAME,
  INVALID_ZIP_CODE,
} from "../../../configurations/MessageConstants";

function WellOwner(props) {
  const [validated, setValidated] = useState(false);
  const [stateArray, setStateArray] = useState([]);

  const back = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  const saveAndContinue = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      props.nextStep();
    }
    setValidated(true);
  };
  useEffect(() => {
    let states = [];
    _.forEach(STATES, (value) => {
      let stateObj = {};
      stateObj.value = value;
      stateObj.label = value;
      states.push(stateObj);
    });
    setStateArray(states);
  }, []);

  return (
    <Container>
      <br></br>
      <h3 className="mt-2">Well Owner</h3>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveAndContinue}>
        <div className="well-test-form-body">
          <Row>
            <Form.Group as={Col} controlId="formWellOwnerName" md={6}>
              <Form.Label className="label required-field">
                Well Owner Name
              </Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.wellOwnerName}
                name="wellOwnerName"
                required
                onChange={props.handleChange}
              />
              <Form.Control.Feedback type="invalid">
                {ENTER_WELL_OWNER_NAME}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} controlId="formPhone" md={6}>
              <Form.Label className="label">Mobile Phone Number</Form.Label>
              <MaskedInput
                type="text"
                size="md"
                name="phone"
                autoComplete="off"
                className={"form-control form-control-md"}
                onChange={props.handleChange}
                pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$"
                mask={[
                  "(",
                  /[1-9]/,
                  /\d/,
                  /\d/,
                  ")",
                  " ",
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                defaultValue={props.inputValues.phone}
              />
              <Form.Control.Feedback type="invalid">
                {ENTER_VALID_PHONE_NUMBER}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group controlId="formAddress" md={12}>
              <Form.Label className="label">Street Address</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.address}
                name="address"
                onChange={props.handleChange}
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} controlId="formCity" md={4}>
              <Form.Label className="label">City</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.city}
                name="city"
                onChange={props.handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formState" md={4}>
              <Form.Label className="label">State</Form.Label>
              <Select
                name="state"
                options={stateArray}
                className={
                  validated ? "well-test-form-validation-success" : EMPTY
                }
                styles={CUSTOM_WELL_FORM_SELECT_STYLES}
                onChange={props.handleStateChange}
                value={props.inputValues.state}
                isClearable={true}
                isSearchable={true}
                menuPlacement="top"
                placeholder="-- Select State --"
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formZip" md={4}>
              <Form.Label className="label">Zip Code</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                defaultValue={props.inputValues.zip}
                name="zip"
                onChange={props.handleChange}
                maxLength="10"
                pattern="^[0-9]*"
              />
              <Form.Control.Feedback type="invalid">
                {INVALID_ZIP_CODE}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
        </div>
        <Button variant="primary" onClick={back}>
          Back
        </Button>
        <Button variant="primary" className="well-test-next-btn" type="submit">
          Next
        </Button>
      </Form>
    </Container>
  );
}

export default WellOwner;
